<template lang="pug">
.cp-team-honer
  .w
    .title 团队殊荣
    ul.logo-list
      li.item(v-for="v in list1")
        img(:src="v.img")
        img.reflect(:src="v.img")
        p {{v.label}}
    ul.certificate-list
      li.item(v-for="item in list3")
        img(:src="item.img")
        p {{ item.label }}
    ul.list2
      li.item2(v-for="v in list2")
        img(:src="v.img")
        .right
          p {{v.title}}
          p {{v.content}}
    rightsSwipper
    partner
</template>
<script>
import partner from './partner'
import rightsSwipper from './rights-swipper'

export default {
  components: {
    partner,
    rightsSwipper,
  },
  props: {},
  data () {
    return {
      list1: [
        { img: require('@/assets/lianmeng-logo.png'), label: '中国人工智能产业发展联盟（AIIA）会员单位' },
        { img: require('@/assets/chuangye-logo.png'), label: '2019年“科技创新行动计划” 创新扶持获奖单位' },
        { img: require('@/assets/gaoxin-logo.png'), label: '2019年度上海特专高新中小企业' },
        { img: require('@/assets/jishuqiye-logo.png'), label: '上海高新技术企业入库' },
      ],
      list2: [
        { img: require('@/assets/xukezheng1.jpg'), title: '电信增值业务许可证', content: '去电获得国家工信部颁发的全国呼叫中心第二类增值业务许可证。本次许可证的取得将促进去电AI话务、人工外呼等业务板块的协同发展，为公司的发展战略进一步夯实基础。' },
        { img: require('@/assets/xukezheng2.jpg'), title: '政府安全认证', content: '万蚓语音交互管理平台获得国家信息系统安全等级保护认证证书，这一方面意味着去电人工智能在信息安全领域所做的努力获得了国家权威机构的认可与背书。' },
      ],
      list3: [
        { img: require('@/assets/about-us-zs-1.png'), label: '杨浦区双创小巨人' },
        { img: require('@/assets/about-us-zs-2.png'), label: '2020年杨浦区“专精特新”中小企业' },
        { img: require('@/assets/about-us-zs-3.png'), label: '上海市科技小巨人企业' },
        { img: require('@/assets/about-us-zs-4.png'), label: '上海市“专精特新”中小企业' },
      ]
    }
  },
  computed: {},
  methods: {}
}
</script>
<style lang="stylus">
.cp-team-honer
  background url('../../../assets/about-bg2.jpg') bottom center / 100% no-repeat
  padding-bottom 197px
  .title
    margin-bottom 122px
  .logo-list
    padding 0px 79px
    margin-bottom 91px
    display flex
    justify-content space-between
    .item
      width 188px
      .reflect
        opacity 0.1
        transform rotate3d(1, 0, 0, 180deg)
      img
        display block
        margin 0 auto
      p
        text-align center
        opacity 0.6
        margin-top -16px
      &:first-child
        width 178px
        padding-top 5px
        img
          width 162px
      &:nth-child(2)
        width 188px
        img
          width 151px
      &:nth-child(3)
        width 148px
        padding-top 10px
        img
          width 64px
        p
          margin-top -10px
      &:nth-child(4)
        width 140px
        img
          width 110px
          margin-top -3px
        p
          margin-top -20px
  .certificate-list
    display: flex
    align-items: center
    justify-content: space-between
    gap 20px
    margin-bottom: 90px
    text-align: center
    img
      width 267px
      margin-bottom: 20px
    p
      color: rgba(255,255,255,.6)
  .list2
    margin-bottom 80px
    display flex
    justify-content space-between
    .item2
      position relative
      width 543px
      height 241px
      padding 35px 42px 45px 39px
      background rgba(28,42,87,1)
      display flex
      justify-content space-between
      align-items center
      &::after
        content ''
        display block
        width 107px
        height 105px
        background url('../../../assets/renzheng.png') center / 100% no-repeat
        position absolute
        right 0
        bottom 0
      img
        width 108px
      .right
        width 309px
        height 100%
        p
          &:first-child
            font-size 24px
            margin-bottom 14px
          &:last-child
            font-size 16px
            line-height 28px
      &:last-child
        padding-left 26px
        padding-right 24px
        img
          width 137px

</style>
